import { apiCall } from './gqlClient';
const GETUSERWORKOUTPROGRESSDETAILS_QUERY = "\n  query getUserWorkoutProgressDetails($id: String!) {\n    getUserWorkoutProgressDetails(id: $id)\n    {\n      id\n\t\t\tuserId\n\t\t\tworkoutId\n\t\t\tuserPlanId\n\t\t\tduration\n\t\t\tdateCreated\n\t\t\ttotalPercentage\n\t\t\tproviderId\n\t\t\tnote\n\t\t\trating\n\t\t\tworkoutTitle\n\t\t\tplanTitle\n\t\t\tgroupId\n      ...fragments\n    }\n  }";
export const getUserWorkoutProgressDetailsApiCall = async function (_ref) {
  let {
    id
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETUSERWORKOUTPROGRESSDETAILS_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const GETUSERWORKOUTPROGRESSDETAILSBYOWNER_QUERY = "\n  query getUserWorkoutProgressDetailsByOwner($userId: Int!, $userPlanId: String!) {\n    getUserWorkoutProgressDetailsByOwner(userId: $userId, userPlanId: $userPlanId)\n    {\n      planTitle\n\t\t\tworkoutTitle\n\t\t\tuserId\n      ...fragments\n    }\n  }";
export const getUserWorkoutProgressDetailsByOwnerApiCall = async function (_ref2) {
  let {
    userId,
    userPlanId
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETUSERWORKOUTPROGRESSDETAILSBYOWNER_QUERY,
    variables: {
      userId,
      userPlanId
    },
    fragments
  });
};
const GETUSERWORKOUTPROGRESSDETAILSBYGROUP_QUERY = "\n  query getUserWorkoutProgressDetailsByGroup($groupId: Int!, $groupPlanId: String!) {\n    getUserWorkoutProgressDetailsByGroup(groupId: $groupId, groupPlanId: $groupPlanId)\n    {\n      groupName\n\t\t\tplanTitle\n\t\t\tgroupId\n      ...fragments\n    }\n  }";
export const getUserWorkoutProgressDetailsByGroupApiCall = async function (_ref3) {
  let {
    groupId,
    groupPlanId
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETUSERWORKOUTPROGRESSDETAILSBYGROUP_QUERY,
    variables: {
      groupId,
      groupPlanId
    },
    fragments
  });
};
const GETALLUSERWORKOUTACTIVITIES_QUERY = "\n  query getAllUserWorkoutActivities($userId: Int!) {\n    getAllUserWorkoutActivities(userId: $userId)\n    {\n      id\n\t\t\tuserId\n\t\t\tworkoutId\n\t\t\tuserPlanId\n\t\t\tduration\n\t\t\tdateCreated\n\t\t\ttotalPercentage\n\t\t\tproviderId\n\t\t\tnote\n\t\t\trating\n\t\t\tworkoutTitle\n\t\t\tplanTitle\n\t\t\tgroupId\n      ...fragments\n    }\n  }";
export const getAllUserWorkoutActivitiesApiCall = async function (_ref4) {
  let {
    userId
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETALLUSERWORKOUTACTIVITIES_QUERY,
    variables: {
      userId
    },
    fragments
  });
};
const GETUSERWORKOUTPROGRESSMONTHS_QUERY = "\n  query getUserWorkoutProgressMonths {\n    getUserWorkoutProgressMonths\n  }";
export const getUserWorkoutProgressMonthsApiCall = async () => apiCall({
  query: GETUSERWORKOUTPROGRESSMONTHS_QUERY,
  variables: {}
});
const GETUSERWORKOUTPROGRESSPERIOD_QUERY = "\n  query getUserWorkoutProgressPeriod($periodDays: Int!) {\n    getUserWorkoutProgressPeriod(periodDays: $periodDays)\n    {\n      workoutsFinished\n\t\t\ttotalProgress\n      ...fragments\n    }\n  }";
export const getUserWorkoutProgressPeriodApiCall = async function (_ref5) {
  let {
    periodDays
  } = _ref5;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETUSERWORKOUTPROGRESSPERIOD_QUERY,
    variables: {
      periodDays
    },
    fragments
  });
};
const GETUSERWORKOUTPROGRESSFORMONTH_QUERY = "\n  query getUserWorkoutProgressForMonth($date: DateTime!) {\n    getUserWorkoutProgressForMonth(date: $date)\n    {\n      totalPercentage\n\t\t\tdateCreated\n\t\t\tduration\n\t\t\ttotalExercises\n\t\t\tmaxWeight\n\t\t\texercises\n      ...fragments\n    }\n  }";
export const getUserWorkoutProgressForMonthApiCall = async function (_ref6) {
  let {
    date
  } = _ref6;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETUSERWORKOUTPROGRESSFORMONTH_QUERY,
    variables: {
      date
    },
    fragments
  });
};
const CREATEUSERWORKOUTPROGRESS_QUERY = "\n  mutation createUserWorkoutProgress($request: UserWorkoutProgressInput!) {\n    createUserWorkoutProgress(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const createUserWorkoutProgressApiCall = async function (_ref7) {
  let {
    request
  } = _ref7;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATEUSERWORKOUTPROGRESS_QUERY,
    variables: {
      request
    },
    fragments
  });
};